import React, { useMemo, useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getUrl } from "src/Utils/Common";
import MarketeersBackground from "./MarketeersBackground";
import backgroundProject from "src/Assets/MarketeersLogo.png";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const token = useMemo(() => localStorage.getItem("userId") || "", []);

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New password and confirmation do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${getUrl()}/auth/change_password`,
        {
          current_password: currentPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
            "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
          },
        }
      );

      if (res.status === 200 || res.status === 201) {
        localStorage.setItem("requiresPasswordChange", "false");
        setSuccess("Password updated successfully.");

        const role = localStorage.getItem("role");
        if (role === "free_trial") navigate("/upload-excel", { replace: true });
        else navigate("/select-user-id", { replace: true });
      } else {
        setError("Failed to change password. Please try again.");
      }
    } catch (e) {
      console.error("Change password error:", e?.response || e);
      if (e?.response) {
        const backendMsg =
          e.response.data?.message ||
          e.response.data?.error ||
          e.response.data?.detail ||
          (typeof e.response.data === "string" ? e.response.data : null);

        setError(
          backendMsg
            ? `Change password failed: ${backendMsg}`
            : `Change password failed (HTTP ${e.response.status}).`
        );
      } else {
        setError("Change password failed: network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} md={6}>
        <MarketeersBackground src={backgroundProject} />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#F4F6FB",
          p: { xs: 2, sm: 4 },
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "100%",
            maxWidth: 480,
            borderRadius: 4,
            p: { xs: 3, sm: 4 },
            boxShadow: "0 14px 35px rgba(0,0,0,0.08)",
          }}
        >
          <Box mb={2} textAlign="left">
            <Typography variant="overline" sx={{ color: "#929292", letterSpacing: 1 }}>
              Action required
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "primary.main" }}>
              Change your password
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: "#555" }}>
              You must update your password before continuing.
            </Typography>
          </Box>

          {error && (
            <Typography color="error" sx={{ mb: 2, fontWeight: 700 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success.main" sx={{ mb: 2, fontWeight: 700 }}>
              {success}
            </Typography>
          )}

          <TextField
            fullWidth
            label="Current password"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            sx={{ mb: 2 }}
            disabled={loading}
          />
          <TextField
            fullWidth
            label="New password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
            disabled={loading}
          />
          <TextField
            fullWidth
            label="Confirm password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 2 }}
            disabled={loading}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
            sx={{ borderRadius: 3, fontWeight: "bold", textTransform: "uppercase", py: 1 }}
          >
            {loading ? "Updating..." : "Update password"}
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;

